import { EP_PACKAGE_DOCUMENTS } from '../../functions/src/common/epAdvanceWorkflow';
import { EP_V2_REVIEW_ITEMS } from '../../functions/src/common/epAdvanceV2';

export function epSurveyV2PublishBlockers(survey: {
    research: { filterVersion?: number } | null;
    documents: Record<string, string>;
    qa: { checked: number[]; signature: string };
}): string[] {
    const blockers: string[] = [];
    if (!survey.research)
        blockers.push('Gather fresh research before publishing.');
    else if (survey.research.filterVersion !== 2)
        blockers.push('Refresh research before publishing.');
    if (EP_PACKAGE_DOCUMENTS.some(item => (survey.documents[item.key] || '').trim().length < 100))
        blockers.push('Review all five complete document drafts before publishing.');
    if (!EP_V2_REVIEW_ITEMS.every((_, index) => survey.qa.checked.includes(index)))
        blockers.push('Complete all seven verification checks.');
    if (!survey.qa.signature.trim())
        blockers.push('Enter your typed consultant sign-off.');
    return blockers;
}
